import { type ApolloError } from '@apollo/react-hooks';

export enum NominationDeclaration {
  NO_INTEREST_CONFLICT = 'NO_INTEREST_CONFLICT',
  NOT_REGISTER_HIGHER_DEGREE = 'NOT_REGISTER_HIGHER_DEGREE',
  INFORMATION_TRUE = 'INFORMATION_TRUE',
  APPLICANT_MEET_HKPFS_THRESHOLD = 'APPLICANT_MEET_HKPFS_THRESHOLD',
  ADMISSION_USING_EXTERNAL_OR_DEA = 'ADMISSION_USING_EXTERNAL_OR_DEA',
  NO_RESEARCH_COLLABORATION_WITH_PARTNER_CHIEF_SUPERVISOR = 'NO_RESEARCH_COLLABORATION_WITH_PARTNER_CHIEF_SUPERVISOR',
}
export type DeclarationValues = {
  content: NominationDeclaration;
  confirmed: boolean;
  justification?: string;
};
export type GetDeclaration = {
  declarations: DeclarationValues[];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};
